export default "__VITE_ASSET__cc43c65a__"